import moment from "moment";

/**
 * Parsea líneas de texto extraídas de un PDF de Levic.
 * Retorna un Map<descripcionLower, { lotes, cantidadLinea }>
 *
 * Formato real del PDF (dos filas por producto):
 *   Línea principal: CLAVE DESCRIPCION CVEPROD(8 dig) CANTIDAD H87 PZA PRECIO ...
 *   Línea de lote:   *CLAVE LOTE / DD-MM-YYYY CANTIDAD
 */
export function parsearLineasLevic(allLines) {
  // Línea principal: ancla en cveprod (8 dígitos consecutivos) + H87 PZA
  const MAIN_LINE = /^([A-Z]{2,6}\d+)\s+(.+?)\s+\d{8}\s+(\d+)\s+H87[\s/]+PZA/i;
  // Línea de lote: empieza con * (con posible espacio), formato LOTE / DD-MM-YYYY CANTIDAD
  const LOTE_LINE = /^\*\s*([A-Z]{2,6}\d+)\s+(\S+)\s+\/\s+(\d{2}-\d{2}-\d{4})\s+(\d+)/i;

  const claveToDesc = new Map();   // clave -> { descripcion, cantidad }
  const claveToLotes = new Map();  // clave -> [{ numero, caducidad, cantidad }]

  for (const line of allLines) {
    const mLote = line.match(LOTE_LINE);
    if (mLote) {
      const clave = mLote[1].toUpperCase();
      const numero = mLote[2];
      const caducidad = moment(mLote[3], 'DD-MM-YYYY');
      const cantidad = parseInt(mLote[4], 10);
      if (!claveToLotes.has(clave)) claveToLotes.set(clave, []);
      const lotes = claveToLotes.get(clave);
      const dup = lotes.find(l => l.numero === numero);
      if (dup) {
        dup.cantidad = (Number(dup.cantidad) || 0) + cantidad;
      } else {
        lotes.push({ numero, caducidad, cantidad });
      }
      continue;
    }

    const mMain = line.match(MAIN_LINE);
    if (mMain) {
      const clave = mMain[1].toUpperCase();
      if (!claveToDesc.has(clave)) {
        claveToDesc.set(clave, { descripcion: mMain[2].trim(), cantidad: parseInt(mMain[3], 10) });
      }
    }
  }

  const productsByDesc = new Map();
  for (const [clave, { descripcion, cantidad }] of claveToDesc) {
    const key = descripcion.toLowerCase();
    if (!productsByDesc.has(key)) productsByDesc.set(key, { lotes: [], cantidadLinea: null });
    const entry = productsByDesc.get(key);
    const lotes = claveToLotes.get(clave) || [];
    if (lotes.length > 0) {
      for (const l of lotes) {
        const dup = entry.lotes.find(x => x.numero === l.numero);
        if (dup) {
          dup.cantidad = (Number(dup.cantidad) || 0) + Number(l.cantidad);
        } else {
          entry.lotes.push(l);
        }
      }
    } else {
      entry.cantidadLinea = (entry.cantidadLinea || 0) + cantidad;
    }
  }

  return productsByDesc;
}